const currentHealthActions = state => state.currentHealthActions

const choosenHealthActions = state => state.choosenHealthActions

const currentHealthActionsCount = state => {
  const healthActions = state.choosenHealthActions ?? state.currentHealthActions
  const allActions = healthActions
    .map(group => group.actions)
    .flat()
    .filter(action => action.checked)

  const followUpActions = allActions.filter(action => action.autoExec)

  return {
    followUp: followUpActions.length,
    wanda: allActions.length - followUpActions.length
  }
}

const hasFollowUpConflict = state =>
  state.currentHealthActions.filter(actions => actions.isFollowUp).length > 1

export default {
  currentHealthActions,
  choosenHealthActions,
  currentHealthActionsCount,
  hasFollowUpConflict
}
